import { Modal, Box } from '@mui/material';
import { find } from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import { useDemoVideos } from 'store/resources/selectors'
import styled from "styled-components"
import { closeModal } from "utils/assets/images"
import SentryWrap from 'components/Sentry';



const VideoModal = styled.video`
    height:100%;
    width:100%;
`;
const VideoContainer = styled.div`
        display: flex;
        justify-content: center;
        // height: 50vh;
        // height: auto;
        // background: #fff;
        align-items: center;
`;


const PreviewButton = styled.button`
  background-color: #03989e;
  color: white;
  padding: 7px 16px;
  font-size: 0.875rem;
  min-width: 64px;
  box-shadow: none;
  border-radius: 22px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 500;
  line-height: 1.75;
  text-transform: uppercase;
  outline-width: 0px;
  border: 0px;
  cursor: pointer;
  height:38px;
  &:hover {
    background-color: rgba(2, 15, 90);
    box-shadow: none;
  }

  &:active {
    box-shadow: none;
  }
`;


export default function DemoPreview({ style = {}, video_id , wrapperStyle = {} }) {
    const demoVideos = useDemoVideos()
    const [demoModal, setdemoModal] = useState(false);
    const video_item = useMemo(() => {
        if (!video_id) return null
        return find(demoVideos, { id: video_id })
    }, [video_id, demoVideos]);


    useEffect(() => {


    }, [video_id, demoVideos])
    const hidedemoModal = () => {
        setdemoModal(false)
    }
    const viewdemoModal = () => {
        setdemoModal(true)
    }

    return (
        <SentryWrap>
        <div style={{ display: "flex", ...wrapperStyle }}>
            <Modal open={demoModal} onClose={hidedemoModal} className="modelCntnt">
                <Box sx={{}} className="modelCntntIner">
                    <div className="lernModalBg">
                        <VideoContainer className="modelDtl">
                            <VideoModal controls controlsList="nodownload" autoPlay src={video_item?.src} poster={video_item?.poster} />
                            <img src={closeModal} onClick={hidedemoModal} className="closeModelInfo" />
                        </VideoContainer>
                    </div>
                </Box>
            </Modal>
            {video_item && video_item.metadata.active ? <PreviewButton
                style={style}
                onClick={viewdemoModal}
                onTouchStart={viewdemoModal}
                disabled={!video_item}
            >Preview
            </PreviewButton> : null}
        </div>
        </SentryWrap>
    )
}






